import { useEffect, useState } from "react";
import { CheckCircle, XCircle } from "lucide-react";

const Receipt = () => {
  const [paymentStatus, setPaymentStatus] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const order = params.get("order");
    const status = params.get("status");
    const desc = params.get("desc");
    const amount = params.get("amount");
    const bank = params.get("payer_bank_name");

    setPaymentStatus({
      order,
      status,
      desc,
      amount,
      bank: bank ? decodeURIComponent(bank) : null,
    });
  }, []);

  if (!paymentStatus) return null;

  const isSuccess = paymentStatus.status === "3"; // BayarCash success = 3

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white shadow-lg rounded-xl p-6 w-full max-w-md text-center">
        {isSuccess ? (
          <CheckCircle className="mx-auto text-green-600" size={60} />
        ) : (
          <XCircle className="mx-auto text-red-600" size={60} />
        )}
        <h2 className="text-2xl font-bold mt-4">
          {isSuccess ? "Payment Successful!" : "Payment Failed"}
        </h2>
        <p className="mt-2 text-gray-600">{paymentStatus.desc}</p>

        <div className="mt-6 text-left space-y-2 text-sm">
          <div>
            <span className="font-medium">Reference No:</span>{" "}
            {paymentStatus.order}
          </div>
          <div>
            <span className="font-medium">Amount:</span> RM{" "}
            {parseFloat(paymentStatus.amount).toFixed(2)}
          </div>
          {paymentStatus.bank && (
            <div>
              <span className="font-medium">Bank:</span> {paymentStatus.bank}
            </div>
          )}
        </div>

        <a
          href="/"
          className="mt-6 inline-block text-sm text-blue-600 hover:underline"
        >
          Go back to homepage
        </a>
      </div>
    </div>
  );
};

export default Receipt;
